import { defineMessages } from "react-intl";

/** COM-737 — fixed field labels (shown as placeholders) of the Become a Partner form. */
const messages = defineMessages({
  fullName: { id: "partnerForm.form.full_name", defaultMessage: "Full Name" },
  companyName: {
    id: "partnerForm.form.company_name",
    defaultMessage: "Company Name",
  },
  jobTitle: { id: "partnerForm.form.job_title", defaultMessage: "Job Title" },
  email: { id: "partnerForm.form.email", defaultMessage: "Email Address" },
  phone: { id: "partnerForm.form.phone", defaultMessage: "Phone Number" },
  message: {
    id: "partnerForm.form.message",
    defaultMessage: "Anything else you'd like us to know?",
  },
  rateLimited: {
    id: "partnerForm.form.rate_limited",
    defaultMessage: "Too many attempts. Please try again in a few minutes.",
  },
});

export default messages;
